import { Directive, OnInit, inject } from '@angular/core'

import { FlxSelectComponent } from '@flowx/angular-ui-toolkit'
import { theme } from '@flowx/core-sdk'
import { ThemeComponent, getComponentStyles } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-select:not([multi])',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.Select }],
})
export class FlxSelectThemeDirective implements OnInit {
  selectComponent = inject(FlxSelectComponent)

  ngOnInit(): void {
    const styleClass = getComponentStyles(ThemeComponent.SelectOption, theme())
    this.selectComponent.optionClass.set(`${styleClass} flx-themed`)
  }
}
